<div class="w-full h-full min-h-[10.375rem] sm:min-h-[16.875rem] md:min-h-[15.1875rem] lg:min-h-[16.5rem] flex flex-col gap-[0.75rem]">
  @let deployment = loggerDeployment();
  @let dataAvailable = isDataExist();
  @let requestError = error();

  @if (deployment) {
    @if (!requestError) {
      <div class="grow-1 min-h-0 overflow-y-auto px-[0.75rem] sm:px-[1rem] py-[0.75rem]">
        @if (dataAvailable) {
          <div class="flex flex-wrap gap-[0.25rem]">
            @for (picture of data(); track picture.id) {
              <gc-picture-gallery-list-item [picture]="picture" (pictureSelect)="onPictureSelect($event)" />
            }
          </div>
        } @else {
          <div class="flex flex-col gap-[0.75rem]">
            <div translate="@@shared-no-pictures-available_label" class="text-[0.875rem] font-[600] leading-[150%] text-(--p-primary-500)"></div>
            <div translate="@@shared-no-pictures-available_info" class="text-[0.75rem] font-[500] leading-[150%] text-(--p-gray-950)"></div>
          </div>
        }
      </div>
    } @else {
      <div class="grow-1 items-center justify-center min-h-[6.25rem] flex flex-col px-[0.75rem] sm:px-[1rem]">
        <gc-floating-popup-base-error-message [isMinimized]="true" [requestError]="requestError"></gc-floating-popup-base-error-message>
      </div>
    }
  }
</div>
